import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Overlay portal (Owner task book 2026-09-04 Round 2 §X — ONE shared overlay architecture).
//
// Root cause of "the page behind the Unable sheet moves while the sheet stays": an overlay rendered
// INSIDE another sheet lives, in the DOM, inside that sheet's scroll container. A touch the inner
// sheet cannot consume chains to the nearest scrollable ANCESTOR — the outer sheet — no matter that
// the overlay is position:fixed. The body lock (src/ui/scrollLock.ts) cannot stop that: the outer
// sheet is not the body.
//
// Every overlay therefore renders through this portal into one dedicated root that is a direct
// child of <body>: its only scrollable ancestor is the document, and the document is locked while
// any overlay is open. React events keep bubbling through the React tree, so the owner components
// behave exactly as before.
export const OVERLAY_ROOT_ID = 'v2-overlay-root';

export function overlayRoot(): HTMLElement {
  let root = document.getElementById(OVERLAY_ROOT_ID);
  if (!root) {
    root = document.createElement('div');
    root.id = OVERLAY_ROOT_ID;
    document.body.appendChild(root);
  }
  return root;
}

export function Portal(props: { children: ReactNode }) {
  if (typeof document === 'undefined') return null;
  return createPortal(props.children, overlayRoot());
}
